import { Button } from '$components'
import { useRescheduleAppointmentForm } from '.'

export function RescheduleAppointmentFormControls() {
  const { onCancel, isLoading } = useRescheduleAppointmentForm()

  return (
    <div className="flex gap-4 mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        type="submit"
        size="lg"
        isLoading={isLoading}
      >
        Reschedule Appointment
      </Button>
    </div>
  )
}
